import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import FiretruckImage from "../components/images/firetruck"
import Firehose from "../components/images/firehose"
import Fireman from "../components/images/fireman"
import MarsdenParkRFSLogo from "../components/images/marsdenParkRFSLogo"
import FadeIn from "react-fade-in"
import "./about.css"
import {
  Card,
  CardTitle,
  CardGroup,
  CardBody,
  CardHeader,
  CardDeck,
} from "reactstrap"

export default function About() {
  return (
    <Layout>
      <SEO title="About" description="Marsden Park RFS About Page"/>
      <div>
        <FadeIn>
          <CardDeck>
            <Card outline color="white">
              <CardBody>
                <h3>Formation</h3>
                <p>
                  Serious fires in NSW and Victoria in 1896 were the catalyst
                  for Bushfire Brigade formations in NSW. In 1906 the Local
                  Government Act authorised Local Government Councils to form
                  Bushfire Brigades throughout the State. Prior to the
                  establishment of Marsden Park Brigade, local residents banded
                  together to fight any outbreaks of fire with whatever
                  resources were available at the time.
                </p>
                <p>
                  Marsden Park Bushfire Brigade, believed to be the oldest in
                  the Blacktown area, was established June 1944, after it was
                  agreed at a P&C meeting at Marsden Park School that the P&C
                  convene a meeting to form a Bushfire Brigade. The Brigade was
                  officially approved by Blacktown Shire Council (now Blacktown
                  City Council) at a Council meeting on the 30<sup>th</sup> of
                  November 1944.
                </p>
              </CardBody>
            </Card>
            <Card outline color="white">
              <CardBody>
                <center>
                  <Fireman />
                </center>
              </CardBody>
            </Card>
          </CardDeck>
          <Card outline color="white">
            <CardBody>
              <h3>Training and Fire Fighting</h3>
              <p>
                In the early years, there was no structured training, it was
                mostly repairing and maintaining the equipment and shed, and
                later keeping the vehicles in order, as well as attending fires
                and creating fire breaks and hazard reductions
              </p>
              <p>
                Lessons were learnt over the years from bushfires and from data
                collected in Fire Weather Researches, where details of all fires
                attended were recorded, as well as competing in Fire
                Demonstrations with other Brigades. Members learnt from watching
                films, going to Fire School, and being taught how to operate
                equipment. In February 1984 the Bushfire Council introduced a
                new training scheme which was compulsory to maintain active
                membership. In 1985 members undertook Basic Training to refresh
                skills.
              </p>
              <p>
                Today, training is intensive. Members start with Basic Fire
                Fighting Training, Village Fire Training and Advanced Training.
                Other training modules include Breathing Apparatus, Chain Saw,
                Crew Leader, Communications, Driving Courses, First Aid, IMT and
                Instructor courses. Training at the Brigade in now held at least
                once a week. The Brigade still participates in Field Days with
                other Brigades. The Brigade attends a range of incidents, grass
                fires, bushfires, motor vehicle accidents and structural fires.
                They also help other emergency services with storm damage,
                missing person searches etc, as well as conducting public
                relations exercises at schools, shopping centres and Santa runs,
                etc. Members also often attend out of area fire commitments to
                assist communities far and wide.
              </p>
            </CardBody>
          </Card>
          <Card outline color="white">
            <CardBody>
              <FiretruckImage />
            </CardBody>
          </Card>
          <CardDeck>
            <Card outline color="white">
              <CardBody>
                <h3>Meetings</h3>
                <p>
                  In the early years, meetings were held fortnightly and
                  sometimes monthly, with a recess during the winter months
                  unless anything of importance came up.
                </p>
                <p>
                  The meetings were often held after the P&C meetings finished
                  as members were often involved with both. Delegates from other
                  Brigades in the area were often invited to meetings to discuss
                  activities.
                </p>
                <p>
                  Today, there is a monthly general meeting with Officers and
                  Executive meetings in alternate months prior to general
                  meetings.
                </p>
              </CardBody>
            </Card>
            <Card outline color="white">
              <CardBody>
                <center>
                  <MarsdenParkRFSLogo />
                </center>
              </CardBody>
            </Card>
          </CardDeck>
          <CardDeck>
            <Card outline color="white">
              <CardBody>
                <center>
                  <Firehose />
                </center>
              </CardBody>
            </Card>
            <Card outline color="white">
              <CardBody>
                <h3>Women's Involvement</h3>
                <p>
                  Women have always been involved in Brigade activities, being
                  an essential and irreplacible part of our team. The role of
                  our female members in our brigade is equally as important and
                  respected as all other members. At present, we have a number
                  of female members and we are actively seeking to increase
                  these numbers.
                </p>
              </CardBody>
            </Card>
          </CardDeck>
          <Card outline color="white">
            <CardBody>
              <h3>Social Activities and Fund Raising</h3>
              <p>
                In the early periods of the Brigade there were raffles, socials,
                dances, door knock appeals and subscription lists. Letters were
                also sent to various people and businesses for donations.
                Advertising for these activities was placed in the local shops
                and buses. Over the years, many businesses and organisations
                have supported the Brigade and still do. We rely on a number of
                local businesses for their support to assist with everyday
                station upkeep and operational requirements if or as required.
                We are extremely thankful to all, as without your support we
                would not be able to serve the community. Fund raising is much
                the same today, with raffles, car washes, trivia nights and
                donations from hazard reductions and hats left at local
                businesses. Social activites are varied with BBQ's with other
                Brigades, cricket matches, fishing, Christmas parties, car
                rallies, movie nights, night tours and Brigade Balls.
              </p>
            </CardBody>
          </Card>
        </FadeIn>
      </div>
      <FadeIn>
        <div style={{ paddingBottom: "1rem", paddingTop: "1rem" }}>
          <CardGroup>
            <Card>
              <CardHeader>
                <CardTitle className="about-card-title">
                  Brigade Captains
                </CardTitle>
              </CardHeader>
              <CardBody>
                <ul>
                  <li>1944-46 John (Jack) Abell</li>
                  <li>1947 Robert Delarue</li>
                  <li>1948, 1956 Vic Gallen</li>
                  <li>1949 Jack Robins</li>
                  <li>1950-51, 1953-55, 1960 John (Jack) Dwyer </li>
                  <li>1952 Gordon Baker</li>
                  <li>1957-59, 1961-69 J.E. (Eric) Graham</li>
                  <li>1970-72 Harry Sabur</li>
                  <li>1973-74 Gordon Shearston</li>
                  <li>1975-77 John Vos</li>
                  <li>1978 Brian Shearston</li>
                  <li>1979 Mike Davey</li>
                  <li>1980-82, 1984, 1986 Wayne Sabur</li>
                  <li>1983, 1985, 1988 Brian Graham</li>
                  <li>1987 Phillip Adorna</li>
                  <li>1989-91 Colin Gray</li>
                  <li>1992-95 David Templeton</li>
                  <li>1996-99 Ian McDonald</li>
                  <li>2000-02 Daryl Judge</li>
                  <li>2003 Matthew Knott</li>
                  <li>2004-14 David Brown</li>
                  <li>2014-16 Jason Field</li>
                  <li>2016-18 Keith Vincent</li>
                  <li>2018-19 Wesley Keaton</li>
                  <li>2019-Current Scott Gray</li>
                </ul>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle className="about-card-title">Life Members</CardTitle>
              </CardHeader>
              <CardBody>
                <ul>
                  <li>John (Jack) Abell</li>
                  <li>Harry Sabur</li>
                  <li>Ron Shields</li>
                  <li>Wayne Sabur</li>
                  <li>Brian Graham</li>
                  <li>Daryl Judge</li>
                  <li>Ian McDonald</li>
                  <li>Matthew Knott</li>
                  <li>Adam Cachia</li>
                  <li>Anthony Smith</li>
                  <li>David Brown</li>
                  <li>Matthew Petrusma</li>
                  <li>Grayson Haora</li>
                  <li>Heather Griffin</li>
                  <li>Donald Deppeler</li>
                  <li>David Templeton</li>
                  <li>Colin Gray</li>
                  <li>Andrew Calver</li>
                </ul>
              </CardBody>
            </Card>
          </CardGroup>
        </div>
      </FadeIn>
    </Layout>
  )
}
